import { PaymentMethodType, } from "../../../../Account/BillingInformation/Shared/types/PaymentProcessorTypes";
export const makeCreditCardOption = (creditCard) => {
    var _a, _b, _c, _d, _e, _f;
    const cardOption = {
        label: `${(_a = creditCard === null || creditCard === void 0 ? void 0 : creditCard.card) === null || _a === void 0 ? void 0 : _a.brand} ****${(_b = creditCard === null || creditCard === void 0 ? void 0 : creditCard.card) === null || _b === void 0 ? void 0 : _b.last4} Exp ${(_d = (_c = creditCard === null || creditCard === void 0 ? void 0 : creditCard.card) === null || _c === void 0 ? void 0 : _c.expiration) === null || _d === void 0 ? void 0 : _d.month}/${(_f = (_e = creditCard === null || creditCard === void 0 ? void 0 : creditCard.card) === null || _e === void 0 ? void 0 : _e.expiration) === null || _f === void 0 ? void 0 : _f.year} ${creditCard.isPrimary ? "*Primary" : ""}`,
        type: PaymentMethodType.CARD,
        creditCard: creditCard,
    };
    return cardOption;
};
export const makeGiftCardOption = (giftCard) => {
    const cardOption = {
        label: `${giftCard.giftCardNumber} - $${giftCard.balance.toFixed(2)}`,
        type: PaymentMethodType.GIFTCARD,
        giftCard: giftCard,
    };
    return cardOption;
};
export const createOptions = (creditCards, giftCards) => {
    const creditCardOptions = creditCards
        ? creditCards === null || creditCards === void 0 ? void 0 : creditCards.map((creditCard) => makeCreditCardOption(creditCard))
        : [];
    const giftCardOptions = giftCards ? giftCards === null || giftCards === void 0 ? void 0 : giftCards.map((giftCard) => makeGiftCardOption(giftCard)) : [];
    return [...creditCardOptions, ...giftCardOptions];
};
export const sortCards = (selectedOptions) => selectedOptions.sort((a, b) => {
    if (a.type === PaymentMethodType.CARD && b.type === PaymentMethodType.GIFTCARD)
        return -1;
    if (a.type === PaymentMethodType.GIFTCARD && b.type === PaymentMethodType.CARD)
        return 1;
    else
        return 0;
});
